// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HXBW","tabsBox":"styles_tabsBox__yyWnW","createButton":"styles_createButton__23-L1"};